// eslint-disable-next-line import/prefer-default-export
export const LANGUAGE = {
  ENGLISH: 'en',
  FRENCH: 'fr',
};
